<template>
  <div id="rightThree" style=" height: 100%;">
    <div id="rightThreeContent" style="margin-left:0%; height: 220px; width: 95%; overflow: scroll; border-radius: 10px;">
      <el-table :data="tableData"
                style="width: 100%; min-height: 220px; background-color: #20337f" :show-header="showHeader"
                :row-class-name="tabRowClassName">
        <el-table-column show-overflow-tooltip
          label="a"
          width="50">
          <template slot-scope="scope">
            <span><div class="beforeCircle" style="height: 10px; width: 10px; background-color: #20a0ff; display: inline-block; margin-right: 2px; border-radius: 50%;"></div></span>
            <span>{{scope.row.a}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="b"
          label="50"
          width="60">
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="c"
          label=""
          width="90">
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="d"
          label="">
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="e"
          label=""
          width="50">
          <template slot-scope="scope">
            <a :href="'/#/realTimeData?alarmPointId='+scope.row.e"  target="_blank" style="color: white">详情</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRightThree',
  props: ['areaId', 'areaName'],
  data(){
    return {
      // 提醒
      ScrollScreen:{
        "version": 1,
        "method": "synthScreen.ScrollScreen",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      showHeader: false,
      count: 20,
      msg:[],
      tableData: [],
      formerTableData:[], // 上一次的数据
      // 获取区域列表
      GetAreaList:{
        "version": 1,
        "method": "area.GetAreaList",
        "params": null
        ,
        "token": "",
        "id": 0
      },
      areas:[],
      interval:null,
    }
  },
  methods:{
    getScrollScreen(init){
      this.ScrollScreen.token = this.$store.state.token;
      console.log('获取提醒');
      console.log(this.ScrollScreen);
      this.$axios.post(this.$newMainUrl, this.ScrollScreen).then(res=> {
        this.formerTableData = JSON.parse(JSON.stringify(this.tableData));
        this.tableData = [];
        console.log('获取提醒请求得到响应');
        console.log(res.data);
        res.data.result.devInformationLists.reverse();
        if(res.data.hasOwnProperty('result')){
          res.data.result.devInformationLists.forEach(item =>{
            let t = {};
            t.a = this.getTypeCH(item.type);
            t.b = this.getAreaNameCN(item.areaId);
            t.c = item.pointName;
            // t.d = item.time.substring(0, item.time.indexOf(" "));
            t.d = item.time;
            t.e = item.alarmPointId;
            t._id = item._id;
            this.tableData.unshift(t);
          })
          this.tableData = this.tableData.splice(0,20);
          let len = 0;
          // 获取与上次不同的行数，也就是新的提醒的长度
          if(init){
            // 不是第一次登陆
            len = this.tableData.length;
          }
          else{
            for(let i = 0;i<this.tableData.length; i++){
              if(this.tableData[i]._id === this.formerTableData[0]._id){
                len = i;
                break;
              }
            }
          }
          let news = document.querySelectorAll('.el-table tbody tr');

          for(let i = 0;i<len;i++){
            news[i].style.opacity = "0";
            news[i].style.backgroundColor = "red";
            new Promise(resolve => {
              let index = 0;
              let opacities = [0,0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
              let anime = setInterval(()=>{
                news[i].style.opacity = opacities[index].toString();
                ++index;
                if(index === 10){
                  clearInterval(anime);
                  resolve();
                }
              }, 100)

            }).then(()=>{
              if(i % 2 === 0){
                setTimeout(()=>{
                  news[i].style.backgroundColor = "rgb(32,51,126)";
                  // setTimeout(()=>{
                  //    this.getScrollDevScreen(false);
                  //  },500);
                },500)
              }else{
                setTimeout(()=>{
                  news[i].style.backgroundColor = "rgb(35,78,182)";
                  // setTimeout(()=>{
                  //   this.getScrollDevScreen(false);
                  // },500);
                },500)
              }

            })
          }

        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },
    // 获取区域列表
    getAreaList(){
      this.GetAreaList.token = this.$store.state.token;
      // console.log('获取区域列表请求');
      // console.log(this.GetAreaList);
      this.$axios.post(this.$newMainUrl, this.GetAreaList).then(res=>{
        console.log('获取区域列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          console.log("length");
          console.log(res.data.result.areaList.length);
          res.data.result.areaList.forEach(item =>{
            let t = {};
            t.areaName = item.areaName;
            t.areaId = item.areaId;
            // console.log(t);
            this.areas.push(t);
            item.childList.forEach(item2 =>{
              let t = {};
              t.areaName = item2.areaName;
              t.areaId = item2.areaId;
              // console.log(t);
              this.areas.push(t);
            })
          })

        }else{
            console.log('获取区域列表失败，' + res.data.error.message);
        }
      })
    },
    getTypeCH(type){
      let res = "";
      switch (type) {
        case "alarmRecord":
          res = "告警";
          break;
        case "inspectRecord":
          res = "巡检";
          break;
        case "reportRecord":
          res = "报修";
          break;
        case "repairRecord":
          res = "维修";
          break;
        case "updateRecord":
          res = "更新";
          break;

        // 暂时处理
        case 'reortRecord':
          res = "报修";
          break;
      }
      return res;
    },
    getAreaNameCN(areaId){
      let res = "";
      this.areas.forEach(item=>{
        if(item.areaId === areaId){
          res = item.areaName;
        }
      })
      return res;
    },
    tabRowClassName({row,rowIndex}){
      let index = rowIndex + 1;
      if(index %2 === 0){
        return 'warning-row'
      }
      else{
        return 'success-row';
      }
    },
    load (){
      this.count += 2;
    }
  },
  mounted(){
    this.getAreaList();
    this.getScrollScreen(true);
    this.interval = setInterval(()=>{
      this.getScrollScreen(false);
    }, 3000);
  },
  watch:{
    // areaName(newValue, oldValue){
    //   // 如果当前地区是南京市，则开始轮询，否则删除
    //   if(newValue === "南京市"){
    //     this.getScrollScreen();
    //     this.interval = setInterval(()=>{
    //       this.getScrollScreen();
    //     }, 3000)
    //   }
    //   else{
    //     clearInterval(this.interval);
    //   }
    // }
  },
  destroyed(){
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message: '结束'
    // })
  },
  computed:{
    rowClass: function (row, index) {
      return {
        "height": "20px",
      }
    }
  }
}
</script>

<style scoped>

</style>
<style lang="scss">
  #rightThree{
    text-align: center;
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 30px;
      font-size: 12px;
      font-family: 黑体;
    }
    .el-table .warning-row{
      background:#234eb6
    }
    .el-table .success-row {
      background: #20337e;
    }

    .el-table__body tr,
    .el-table__body td {
      /*background-color: #20337e;*/
      padding: 0;
      height: 30px;
    }
    .el-table tbody tr >td{
      font-size: 12px;
      transform: scale(1);
    }
    .el-table tbody tr:hover>td {
      background-color:orangered!important
    }
    .el-table tbody tr:hover .beforeCircle {
      background-color:yellow!important
    }
    .el-table__row{
      font-size: 12px;
    }
    div.cell{
      color: white;
      font-weight: normal;
      padding: 0 0 0 5px  !important;
    }
    div.cell:before{
      width: 1px;
      height: 10px;
      background-color: green;
      z-index: 10;
    }
    tr.el-table__row > td{
      font-size: 12px;
      border-bottom: none !important;
    }
    #rightThreeContent::-webkit-scrollbar{
      display: none;
    }
  }
</style>
